import StepFlow from '@/febos/chile/dnt/components/wizard/companies/60100003-2/oficialNumeration/StepFlow';
import StepSignaturePosition from '@/febos/chile/approvals/wizardFlow/wizard/flow/StepSignaturePosition';
import {
  mapApprovalActions, mapApprovalSteps
} from '@/febos/chile/approvals/wizardFlow/config/wizard/forms/approvalsCommons';

export default () => ({
  currentStep: 0,
  steps: [
    {
      title: 'Enviar documento a flujo',
      component: StepFlow,
      isLazy: true
    },
    {
      title: 'Ubicar firmas del documento',
      component: StepSignaturePosition,
      condition: (input) => input.setSignaturePosition,
      isLazy: true,
      draftOnBack: true
    }
  ],
  displayNextTitle: true,
  options: ['submit'],
  submitAction: 'sendToFlow',
  loadAllData: false,
  wizardMapper(rawData) {
    const principal = rawData.adjuntos.find((document) => document.tipo === 'principal');
    console.log('DNT', rawData);
    const { metadata } = rawData;

    let title = '';
    if (metadata) {
      metadata.forEach((field) => {
        if (field.nombre === 'title') {
          title = field.valor;
        }
      });
    }
    const name = metadata ? title : rawData.dnt.nombreDescriptivo;

    return {
      fileUrl: principal.adjuntoUrl,
      fileDescription: rawData.dnt.nombreDescriptivo,
      fileIdFlow: principal.adjuntoId,
      fileName: principal.tipoDescripcion ? principal.tipoDescripcion : principal.adjuntoNombre,
      fileNumber: rawData.numero,
      fileType: rawData.tipo,
      fileCategory: rawData.dnt.claseMercadoPublico,
      fileResumen: name,
      documentType: rawData.dnt.emisorSucursalPais || '',
      documentTypeValue: rawData.dnt.emisorCentroCostoNumero || '',
      documentTypeName: rawData.dnt.emisorCentroCostoNombre,
      document: rawData.dnt.emisorSucursalCiudad || '',
      documentValue: rawData.dnt.emisorSucursalCodigo || '',
      documentName: rawData.dnt.emisorSucursalDireccion || '',
      documentGroup: rawData.dnt.solicitanteGrupoId
    };
  },
  documentMapper(input) {
    const data = {
      ejecucion: {
        descripcion: input.description,
        estampar: input.pdfStamp,
        nombre: input.name,
        numero: input.number,
        unidad: input.documentGroup,
        tipoObjetoCategoria: input.documentTypeName,
        tipoDocumentoId: input.documentTypeId,
        reversible: true,
        firmaPosicionada: input.setSignaturePosition ? 'Y' : 'N',
        plantilla: {
          aprobaciones: {
            nombre: input.name,
            descripcion: input.description,
            estampar: input.pdfStamp,
            foliacion: true,
            reversible: true,
            tipoejecucion: 'N',
            tipoObjeto: input.typeFlowId,
          },
          ...mapApprovalSteps(input),
        }
      },
      documentos: [
        {
          adjuntoId: input.fileIdFlow,
          adjuntoMime: input.fileMime,
          adjuntoNombre: input.fileName,
          adjuntoUrl: input.fileUrl,
          fecha: input.fileDate,
          objetoId: input.fileId,
          objetoNombre: input.fileName,
          tipoObjetoId: input.typeFlowId,
          tipoObjetoTexto: input.typeFlowText
        }
      ],
      gatillacionesPreDefinidas: [
        '451eeaef-4232-4963-84c8-ccf5366130df',
        'f13b799d-8640-4b42-a1e1-2e9044e038b5',
        '451eeaef-4232-4963-84c8-ccf5366130dr'
      ],
      ...mapApprovalActions(input)
    };

    if (input.isControlResolution) {
      data.meta = { oficinaAcciones: ['foliar'], indicador: ['contraloria'] };
    }
    if (input.isResolution) {
      data.meta = { oficinaAcciones: ['foliar', 'tramitar'] };
    }

    return data;
  }
});
